import { Checkbox, CheckboxProps } from "antd";
import { FC, useCallback } from "react";
import {
    Market,
    TaskPromoTagPhotos,
    TaskPromoTagPhotosEntity,
    TaskStatus,
} from "tm-shared/types";

import { ForceStepComplete } from "@/features/ForceStepComplete";
import { useAppDispatch } from "@/hooks/redux";
import { useCompleteTask } from "@/hooks/useCompleteTask";
import { useMakeCommand } from "@/hooks/useRequestQueue";
import { setMdTasksConfig } from "@/store/slices/ui";

import { StyledContainer } from "./Styled";

interface PromoTagPhotosControllerProps {
    market: Market;
    task: TaskPromoTagPhotos;
}

export const PromoTagPhotosController: FC<PromoTagPhotosControllerProps> = ({
    market,
    task,
}) => {
    const dispatch = useAppDispatch();

    const marketId = market.id;
    const taskId = task.id;

    const onChange: CheckboxProps["onChange"] = (e) => {
        dispatch(
            setMdTasksConfig({
                marketId,
                taskId,
                field: "showUncompleted",
                value: e.target.checked,
            }),
        );

        dispatch(
            setMdTasksConfig({
                marketId,
                taskId,
                value: null,
            }),
        );
    };

    const { makeTaskCompleteCommands } = useMakeCommand();
    const completeTask = useCompleteTask({ marketId, taskId });

    const handleForceTaskComplete = useCallback(
        async (comment: string) => {
            const payload: Record<string, TaskPromoTagPhotosEntity> = {};

            task.context.products.forEach(({ barcode }) => {
                payload[barcode] = {
                    barcode,
                    comment,
                    status: TaskStatus.Rejected,
                };
            });

            const commands = await makeTaskCompleteCommands({
                params: { taskId, hasPhoto: false, payload },
                marketId,
            });

            completeTask({ commands });
        },
        [
            completeTask,
            makeTaskCompleteCommands,
            marketId,
            task.context.products,
            taskId,
        ],
    );

    return (
        <StyledContainer>
            <Checkbox onChange={onChange}>Показати невиконані</Checkbox>

            <ForceStepComplete
                onComplete={handleForceTaskComplete}
                taskName={task.name}
                marketName={market.name}
            />
        </StyledContainer>
    );
};
